<template>
  <v-col cols="4">
    <v-card elevation="2" tile>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text></v-card-text>
      <v-card-actions>
        <v-btn
            color="primary"
            text
            @click="navigate()"
            :data-cy="'tile-' + title"
        >
          {{ i18n.t("_NavigateTo") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import i18n from "../helper/i18n"
export default {
  props: {
    title: {
      type: String,
      required: String,
    },
    path: {
      type: String,
    },
  },
  data() {
    return {
      i18n:i18n
    };
  },
  methods: {
    navigate() {
      if (this.path !== undefined) {
        this.$router.push(this.path);
      }
      this.$emit("click");
    },
  },
};
</script>

<style></style>
